import { useContext, useEffect, useState } from "react"
import ApiContext from "src/provider/API/call-service"
import { ScreenTitle, CustomContainer, Form, FormGroup, FlexRow, Button } from "src/style"
import { SidePopupLayout } from "src/component"
import helpers from "src/utils/helpers"

export const LogFailedTransaction: React.FC<any> = ({data, back, close}) => {
    const {API} = useContext(ApiContext)
    const [input, setInput] = useState({txRef: '', date: '', time: '', reason: ''})

    useEffect(() => {
        if (data) setInput({
            ...input,
            txRef: data?.transactionReference, 
            date: data?.transactionDate.split(' ')[0],
            time: data?.transactionDateTime.split('T')[1]
        })
    }, [])

    

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})
    
    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        const payload = {
            accountNumber: data.senderAccountNumber,
            transactionDate: data.transactionDateTime,
            amount: data.amount,
            transactionReference: data.transactionReference,
            reason: input.reason
        }
        await API.logFailedTransaction(payload)
        close()
    }

    return (
        <>
            { 
                <SidePopupLayout close={close}>
                    <ScreenTitle textSize="2.2" fontWeight="700">Log Failed Transaction</ScreenTitle>
                    <CustomContainer topMargin='2.5'>
                        <Form onSubmit={handleProceed}>
                            <FormGroup>
                                <label>Transaction Ref</label>
                                <input 
                                    name='txRef'
                                    value={input.txRef}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    disabled
                                    required
                                />
                            </FormGroup>
                            <FormGroup>
                                <label>Transaction Date</label>
                                <input 
                                    name='date'
                                    value={input.date}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    disabled
                                    required
                                />
                            </FormGroup>
                            <FormGroup>
                                <label>Transaction Time</label>
                                <input 
                                    name='time'
                                    value={input.time}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    disabled
                                    required
                                />
                            </FormGroup>
                            <FormGroup>
                                <label>Reason</label>
                                <textarea 
                                    placeholder='Enter a reason...' 
                                    name='reason'
                                    value={input.reason}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                            
                             <FlexRow justifyContent='flex-end' gap="1.5">
                                <Button 
                                    width='6.7' height='4' bgColor="#ffffff"
                                    borderColor='#D0D5DD' hoverBgColor='#ffffff' 
                                    hoverColor='#0D968F' titleSize='1.4' color="#344054"
                                    onClick={back}
                                >
                                    Back
                                </Button>
                                <Button 
                                    width='8.8' height='4' 
                                    borderColor='#0D968F' hoverBgColor='#ffffff' 
                                    hoverColor='#0D968F' titleSize='1.4'
                                >
                                    Proceed
                                </Button>
                            </FlexRow>
                        </Form>
                    </CustomContainer>
                </SidePopupLayout>
            }
        </>
    )
}
